<template>
  <Row>
    <Col span="5">
    <AutoComplete v-model="valuename" :data="country" @on-select="onselect" @on-search="check" @on-blur="onblur" :filter-method="filterMethod" placeholder="请输入或选择国家/国家地区" :style="{width:'250px'}" ref="countryAuto">
    </AutoComplete>
    </Col>
  </Row>
</template>
<script type="text/javascript">
import Country from '../../../assets/json/country.json'
let countryData = Country.globalCountries;
let countries = [];
for (var i = 0; i < countryData.length; i++) {
  countries.push(countryData[i].cn)
}
export default {
  name: "CountryOptions",
  data() {
    return {
      valuename: "",
      country: countries,
    }
  },
  methods: {
    filterMethod(value, option) {
      return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },
    onselect(value) {
      this.$emit('onSelect');
      this.valuename = value;
      // const has= countries.some((item)=>{return item === this.valuename;});
      // console.log("selected:"+has);

    },
    check() {
      const has = countries.some((item) => { return item === this.valuename; });
      this.$emit('onSearch', has)
    },
    onblur() {
      this.$nextTick(function() {
        // console.log("value:" + this.$refs.countryAuto.value)
        const has = countries.some((item) => { return item === this.valuename; });
        this.$emit('onBlur', has)
      })


    }
  },
}

</script>
<style scoped>
/*.ivu-select-dropdown.ivu-select-dropdown-transfer.ivu-auto-complete {
  height: 300px;
  overflow: auto;
}
*/
</style>
